var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.register = void 0;
const shared = require("@volar/shared");
const transformer = require("../transformer");
const vscode = require("vscode-languageserver-protocol");
const common_1 = require("../utils/common");
const dedupe = require("../utils/dedupe");
const featureWorkers_1 = require("../utils/featureWorkers");
const rename_1 = require("./rename");
function register(context) {
    return (uri, range, codeActionContext) => __awaiter(this, void 0, void 0, function* () {
        const document = context.getTextDocument(uri);
        if (!document)
            return;
        const offsetRange = {
            start: document.offsetAt(range.start),
            end: document.offsetAt(range.end),
        };
        let codeActions = yield (0, featureWorkers_1.languageFeatureWorker)(context, uri, { range, codeActionContext }, (_arg, map, file) => {
            var _a, _b;
            if (!file.capabilities.codeAction)
                return [];
            const _codeActionContext = {
                diagnostics: transformer.asLocations(codeActionContext.diagnostics, range => map.toGeneratedRange(range)),
                only: codeActionContext.only,
            };
            let minStart;
            let maxEnd;
            for (const mapping of map.map.mappings) {
                const overlapRange = (0, common_1.getOverlapRange)(offsetRange.start, offsetRange.end, mapping.sourceRange[0], mapping.sourceRange[1]);
                if (overlapRange) {
                    const start = (_a = map.map.toGeneratedOffset(overlapRange.start)) === null || _a === void 0 ? void 0 : _a[0];
                    const end = (_b = map.map.toGeneratedOffset(overlapRange.end)) === null || _b === void 0 ? void 0 : _b[0];
                    if (start !== undefined && end !== undefined) {
                        minStart = minStart === undefined ? start : Math.min(start, minStart);
                        maxEnd = maxEnd === undefined ? end : Math.max(end, maxEnd);
                    }
                }
            }
            if (minStart !== undefined && maxEnd !== undefined) {
                return [{
                        range: vscode.Range.create(map.virtualFileDocument.positionAt(minStart), map.virtualFileDocument.positionAt(maxEnd)),
                        codeActionContext: _codeActionContext,
                    }];
            }
            return [];
        }, (plugin, document, arg, map) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            const codeActions = yield ((_b = (_a = plugin.codeAction) === null || _a === void 0 ? void 0 : _a.on) === null || _b === void 0 ? void 0 : _b.call(_a, document, arg.range, arg.codeActionContext));
            return codeActions === null || codeActions === void 0 ? void 0 : codeActions.map(_codeAction => {
                return Object.assign(Object.assign({}, _codeAction), { data: {
                        uri,
                        originalItem: _codeAction,
                        pluginId: context.plugins.indexOf(plugin),
                        map: map ? {
                            embeddedDocumentUri: map.virtualFileDocument.uri,
                        } : undefined,
                    } });
            });
        }), (_codeActions, sourceMap) => _codeActions.map(_codeAction => {
            if (!sourceMap)
                return _codeAction;
            if (_codeAction.edit) {
                const edit = (0, rename_1.embeddedEditToSourceEdit)(_codeAction.edit, context.documents);
                if (edit) {
                    _codeAction.edit = edit;
                    return _codeAction;
                }
            }
            else {
                return _codeAction;
            }
        }).filter(shared.notEmpty), arr => arr.flat());
        if (codeActions) {
            return dedupe.withCodeAction(codeActions);
        }
    });
}
exports.register = register;
//# sourceMappingURL=codeActions.js.map